import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';
import departments from '../../../../assets/demo/data/departamentos.json';
import provinces from '../../../../assets/demo/data/provincias.json';
import districts from '../../../../assets/demo/data/distritos.json';
import { IDepartament, IDistrict, IProvince } from './branch-store.interface';

const baseRoute = '/branch-stores';
@Injectable({
  providedIn: 'root'
})
export class BranchStoreService extends CrudService {
  departments: IDepartament[];

  constructor(http: HttpClient) {
    super(http, baseRoute);
  }

  getDepartaments(): IDepartament[] {
    return departments.map((department) => this.getIdName(department));
  }

  getProvinces(departmentId: number): IProvince[] {
    const provincesByDepartment = provinces[departmentId];
    if (!provincesByDepartment) return [];
    return provinces[departmentId].map((province) => this.getIdName(province));
  }

  getDistricts(provinceId: number): IDistrict[] {
    const districtsByProvince = districts[provinceId];
    if (!districtsByProvince) return [];
    return districts[provinceId].map((district) => this.getIdName(district));
  }

  getIdName(site) {
    return {
      id: Number(site.id_ubigeo),
      name: site.nombre_ubigeo.toUpperCase()
    };
  }

  getNameDepartament(departmentId) {
    const data = this.getDepartaments().find(
      (department) => department.id === departmentId
    );
    return data ? data.name : 'SIN DEPARTAMENTO';
  }

  getNameProvince(departmentId, provinceId) {
    const data = this.getProvinces(departmentId).find(
      (province) => province.id === provinceId
    );
    return data ? data.name : 'SIN PROVINCIA';
  }

  getNameDistrict(provinceId, districtId) {
    const data = this.getDistricts(provinceId).find(
      (district) => district.id === districtId
    );
    return data ? data.name : 'SIN DISTRITO';
  }
}
